export default __webpack_public_path__ + "static/media/empty-small.b00c6902.svg";